export default __webpack_public_path__ + "static/media/flag-melilla.b0f02a72.svg";